import Navbar from '@web/Navbar'
import React from 'react'

const Footer = () => {
  return (
    <div className="bg-[#0b2948]">
      <Navbar />
      <div className="text-text-inverted gap-y-5 flex py-8 px-12 md:px-16 flex-col-reverse md:flex-row justify-between">
        <div className="flex flex-col justify-start gap-x-5 items-start">
          <img
            src="/website/rex_powered_by.png"
            alt="Urban Intelligence Logo"
            className="h-10 mb-4"
          />
          © {new Date().getFullYear()} Urban Intelligence. All Rights Reserved.
        </div>
        <div className="flex flex-col mt-4 md:mt-0 items-start justify-start text-sm">
          <h3 className="mb-3">Contact Us</h3>
          <p>Level 3/209 Tuam Street</p>
          <p>Ōtautahi | Christchurch 8011</p>
          <p>info@urbanintelligence.co.nz</p>
        </div>
      </div>
    </div>
  )
}

export default Footer
